import React, { useState } from 'react';

import { LIMIT } from './config';
import Header from './header/Header';
import Footer from './footer/Footer';
import TermSearch from './term-search/TermSearch';
import TermsTable from './term-search/TermsTable';
import { ISearchParams } from './term-search/ISearchParams';
import TermsPagination from './term-search/TermsPagination';
import ExpandingTermRow from './term-search/ExpandingTermRow';

const LandingPage: React.FC = () => {
  const defaultSearchParams = {query: '', offset: 0, limit: LIMIT}

  const [searchParams, setSearchParams] = useState<ISearchParams>(defaultSearchParams)
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)

  const search = {
    searchParams: searchParams,
    setSearchParams: setSearchParams
  }

  const pagination = {
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    totalPages: totalPages,
    setTotalPages: setTotalPages
  }

  const rowsProvider = (termOverview: any) => {
      return (<ExpandingTermRow overview={termOverview} />)
    }

  return (
    <div>
      <Header />
      <div className="container mt-2">
        <TermSearch {...search} />
        <TermsTable {...search} {...pagination} rowsProvider={rowsProvider} />
        <TermsPagination {...search} {...pagination} />
      </div>

      <Footer query={searchParams.query} showXlsExport />
    </div>

  );
}

export default LandingPage;
